import React, { useState } from "react";
import Navbar from "../HomePage/Navbar";
import Footer from "../HomePage/Footer";
import GalleryHero from "./GalleryHero";
import GalleryGrid, { galleryItems } from "./GalleryGrid";
import GalleryTransformation from "./GalleryTransformation";
import GalleryLightbox from "./GalleryLightbox";
import GalleryCTA from "./GalleryCTA";

const categories = [
  { id: "all", name: "All Spaces" },
  { id: "villas", name: "Villas & Rowhouses" },
  { id: "apartments", name: "High-Rise Apartments" },
  { id: "rentals", name: "Ready Rentals" },
  { id: "interiors", name: "Interiors & Painting" },
];

function GalleryIndex({ initialCategory = "all" }) {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCategory, setSelectedCategory] = useState(initialCategory);
  const [activeLightboxItem, setActiveLightboxItem] = useState(null);

  // Filter items matching current criteria
  const currentFilteredItems = galleryItems.filter((item) => {
    const matchesCat =
      selectedCategory === "all" || item.category === selectedCategory;
    const matchesSearch =
      searchQuery.trim() === "" ||
      item.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.location.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.categoryLabel.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCat && matchesSearch;
  });

  const handleOpenLightbox = (item) => {
    setActiveLightboxItem(item);
  };

  const handleCloseLightbox = () => {
    setActiveLightboxItem(null);
  };

  const handlePrevLightbox = () => {
    if (!activeLightboxItem || currentFilteredItems.length === 0) return;
    const currentIndex = currentFilteredItems.findIndex(
      (item) => item.id === activeLightboxItem.id
    );
    const prevIndex =
      (currentIndex - 1 + currentFilteredItems.length) % currentFilteredItems.length;
    setActiveLightboxItem(currentFilteredItems[prevIndex]);
  };

  const handleNextLightbox = () => {
    if (!activeLightboxItem || currentFilteredItems.length === 0) return;
    const currentIndex = currentFilteredItems.findIndex(
      (item) => item.id === activeLightboxItem.id
    );
    const nextIndex = (currentIndex + 1) % currentFilteredItems.length;
    setActiveLightboxItem(currentFilteredItems[nextIndex]);
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <GalleryHero
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
        categories={categories}
        totalItems={currentFilteredItems.length}
      />

      <GalleryGrid
        searchQuery={searchQuery}
        selectedCategory={selectedCategory}
        onOpenLightbox={handleOpenLightbox}
      />

      <GalleryTransformation />

      <GalleryCTA />

      <Footer />

      {/* Lightbox Modal */}
      <GalleryLightbox
        item={activeLightboxItem}
        onClose={handleCloseLightbox}
        onPrev={handlePrevLightbox}
        onNext={handleNextLightbox}
      />
    </div>
  );
}

export default GalleryIndex;
